export default "__VITE_ASSET__a9c21547__"